export enum ClientDocumentGroupName {
  OpenAccount = 'OpenAccount',
  Questionnaire = 'Questionnaire',
  ServiceContract = 'ServiceContract',
}
